import { SettingsPermissions } from "@redotech/account-common/permissions";
import { useRequiredContext } from "@redotech/react-util/context";
import StarIcon from "@redotech/redo-icons/star-01.svg";
import StarFilledIcon from "@redotech/redo-icons/star-01_filled.svg";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";
import { useMatch } from "react-router-dom";

export const CsatItems = memo(function CsatItems() {
  const routes = useRequiredContext(MerchantRoutesContext);

  const canManageCsat = useHasPermission(
    SettingsPermissions.SET_SUPPORT_SETTINGS,
  );

  const legacySupportBaseUrl = routes.legacySupportBaseUrl;
  const csatBaseUrl = `${legacySupportBaseUrl}/csat`;
  const anyChildSelected = useMatch(`${csatBaseUrl}/*`);

  if (!canManageCsat) {
    return null;
  }

  return (
    <RedoSecondaryNavItem
      action={{ type: "button" }}
      anyChildSelected={!!anyChildSelected}
      FilledIcon={StarFilledIcon}
      friendlyName="CSAT"
      id="csat"
      UnfilledIcon={StarIcon}
    >
      <RedoSecondaryNavItem
        action={{ type: "link", href: `${csatBaseUrl}/general` }}
        friendlyName="General"
        id="csat-general"
      />
      <RedoSecondaryNavItem
        action={{ type: "link", href: `${csatBaseUrl}/template` }}
        friendlyName="Templates"
        id="csat-template"
      />
      <RedoSecondaryNavItem
        action={{ type: "link", href: `${csatBaseUrl}/ab-tests` }}
        friendlyName="A/B test"
        id="csat-ab-tests"
      />
    </RedoSecondaryNavItem>
  );
});
